import React from "react";
import { FormText } from "reactstrap";
import { InputWrapper } from "../../../components/inputs/final_form/InputWrapper";
import { AdministrateSelect, AdminOptionableSelect } from "../../components/AdministrateSelect";

export const AdministrateSelectInput = ({
  children,
  input,
  label,
  meta,
  loadOptions,
  defaultOptions,
  SelectComponent = AdministrateSelect,
  ...rest
}) => {
  return (
    <InputWrapper label={label} required={rest.required}>
      <SelectComponent {...input} {...rest} />

      {meta.touched && meta.error && <FormText color="danger">{meta.error}</FormText>}
      {children}
    </InputWrapper>
  );
};

export const AdminOptionableInput = (props) => <AdministrateSelectInput {...props} SelectComponent={AdminOptionableSelect} />;
